// extracted by mini-css-extract-plugin
module.exports = {"Header":"Header--3O1_j","Link":"Link--WPJ6e","Empty":"Empty--1Uomz","Modal":"Modal--SZUR4","Primary":"Primary--3__ir","OkBtn":"OkBtn--2FHYU"};